export default __webpack_public_path__ + "static/media/workflow-newstep.c76185f7.svg";